
/* global $ */
import {  includeJavascript, initVideoListener } from "@api/utils_2020";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
window.escTip = false;


import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide-core.min.css';

export default () => {
    console.log('init dreambox');
   initVideoListener();
   
   function initGallery(photoIndex) {

        const pswpElement = document.querySelectorAll(".pswp")[0];

        const photos = [...document.querySelectorAll("img.catalogPage")].map((photo, index) => {
            return {
                src: photo.dataset.original,
                download_src: photo.dataset.original,
                high_src: photo.dataset.max,
                w: window.innerWidth,
                h: window.innerHeight,
                index
            };
        });

        const options = {
            index: photoIndex,
            downloadEl: true,
            zoomEl: false,
            shareEl: true,
            getDoubleTapZoom: function(isMouseClick, item) {
                if(isMouseClick) {
                    gallery.shout("mouseZoom", item);
                    item.resized = true;
                    return 3; //<---- This 4
                } else {
                    return item.initialZoomLevel < 0.7 ? 3 : 2; //<---- 4 here
                }
            },
            tapToToggleControls: false
        };

        if (tv)
        {
            options.shareButtons = [];
        }
        else
        {
            options.shareButtons = [
                {id:'download', label:'Download', url:'{{raw_image_url}}', download:true}
            ];
        }

        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, photos, options);

        gallery.listen("mouseZoom", function(item) {
            if (!item.resized) {
                photos[item.index].src = item.high_src;

                // Update gallery content.
                gallery.invalidateCurrItems();
                gallery.updateSize(true);
            }
        });
        
        gallery.listen("close", function(e) {
            $("body").removeClass("noScroll");
        })
        

        // Image loaded
        gallery.listen('imageLoadComplete', function(index, item) {                 
            $("body").addClass("noScroll");
        });

        gallery.init();
    }

    new Splide(document.querySelector(".splide"), {
        pagination: false,
        perPage: 7,
        perMove: 1,
        autoWidth: false,
        gap: "10px",
        arrows: true,
        breakpoints: {
            1439: { perPage: 5 },
            920: { perPage: 4 },
            439 : { perPage: 2 },
            360 : { perPage: 1 },
          },
      }).mount();
      
    $('#canvas').hide();
    
    $('.coverPage').on('click', function(e)
    {
        initGallery(0);
    });
}
